export const getLineItemMetadata = (item = {}) => ({
  parent_product_id: item?.parent_product_id,
  parent_variant_id: item?.parent_variant_id,
  parent_product_sku: item?.parent_product_sku,
  parent_quantity: item?.parent_quantity,
  parent_item_id: item?.parent_item_id,
  parent_title: item?.parent_title,
  parent_variant: item?.parent_variant,
  parent_product_price: item?.parent_product_price,
  parent_image_url: item?.parent_image_url,
  wms_product_id: item?.wms_product_id,
  wms_variant_id: item?.wms_variant_id,
  wms_sku: item?.wms_sku,
  wms_item_id: item?.wms_item_id,
  wms_shelf_code: item?.wms_shelf_code,
  wms_facility_code: item?.wms_facility_code,
  wms_facility_name: item?.wms_facility_name,
  wms_quantity: item?.wms_quantity,
  wms_product_price: item?.wms_product_price,
  wms_title: item?.wms_title,
  wms_variant: item?.wms_variant,
  wms_image_url: item?.wms_image_url,
  replacement: item?.replacement,
  replacement_eligible: item?.replacement_eligible,
  replacement_applicable: item?.replacement_applicable,
});

export default getLineItemMetadata;
